import React, { Component } from 'react';

import './ForgotPassword.css';
import Page from '@acri-tools/react-tools/components/Page/Page';
import { bannerImage } from '../../theme/images';
import { push_history } from '@acri-tools/react-tools/utils/global';
import FP from '@acri-tools/react-tools/components/_user_manager/ForgotPassword/ForgotPassword';

interface Props {
}

export default class ForgotPassword extends Component<Props> {
    render() {
        return (
            <Page
                id="forgot-password"
                topBar
            >
                <div
                    className="page-content"
                    style={{
                        backgroundImage: `url(${bannerImage})`
                    }}
                >
                    <div id="login-container" className="form-container">

                        <FP />

                        <h2 className="divider"><div className="line" /><span>I REMEMBER MY LOGIN</span><div className="line" /></h2>
                        <div className="login-alt">
                            <div className="custom-button inverted login  themed inverted shadow rounded" onClick={() => { push_history('/login'); }}>
                                <i className="fas fa-sign-in-alt" />
                                LOGIN
                            </div>
                        </div>
                    </div>
                </div>
            </Page>
        );
    }
};

